import React, { useState } from "react";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, CardHeader, Grid, TextField, Input, InputAdornment, InputLabel, Tooltip } from "@material-ui/core";
import { TagsKanbanContainer } from "../TagsKanbanContainer";

const useStyles = makeStyles((theme) => ({
	subheaderContent: {
		display: "flex",
		flexWrap: "wrap",
		alignItems: "center",
		gap: 8,
		marginTop: 4,
	},
	botIndicator: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 8px",
		borderRadius: 999,
		backgroundColor: "#1565c0",
		color: "#fff",
		fontSize: "0.75rem",
		fontWeight: 600,
		whiteSpace: "nowrap",
	},
}));

const TicketInfo = ({ contact, ticket, onClick }) => {
	const [amount, setAmount] = useState("");
	const classes = useStyles();

	const renderSubheader = () => {
		if (!ticket.user && !ticket.isBot) {
			return null;
		}

		return (
			<div className={classes.subheaderContent}>
				{ticket.user && (
					<span>
						{i18n.t("messagesList.header.assignedTo")} {ticket.user.name}
					</span>
				)}
				{ticket.isBot && (
					<Tooltip arrow placement="top" title={i18n.t("messagesList.header.botHandling")}>
						<span className={classes.botIndicator}>
							{i18n.t("messagesList.header.botHandlingCompact")}
						</span>
					</Tooltip>
				)}
			</div>
		);
	};

	const renderCardReader = () => {
		return (
			<CardHeader
				onClick={onClick}
				style={{ cursor: "pointer" }}
				titleTypographyProps={{ noWrap: true }}
				subheaderTypographyProps={{ component: "div" }}
				avatar={<Avatar src={contact?.urlPicture} alt="contact_image" />}
				title={`${contact?.name || '(sem contato)'} #${ticket.id}`}
				subheader={renderSubheader()}

			/>
		);
	}

	const handleChange = (event) => {
		const value = event.target.value;

		setAmount(value);
	}


	return (
		<React.Fragment>
			<Grid container alignItems="center" spacing={10}>
				{/* Conteúdo do contato à esquerda */}
				<Grid item xs={12}>
					{renderCardReader()}
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default TicketInfo;
